import StatusbarConstants from '../../../constants/statusbar_constants';

function getStatusCssClassModifierByStatus(status) {
    switch (status) {
        case StatusbarConstants.ALL_MISSING:
            return '--empty';
        case StatusbarConstants.DIMENSIONS_MISSING:
            return '--dimensions-missing';
        case StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING:
            return '--tyre-index-and-postcode-missing';
        case StatusbarConstants.SPEED_INDEX_MISSING:
            return '--speed-index-missing';
        case StatusbarConstants.LOAD_INDEX_MISSING:
            return '--load-index-missing';
        case StatusbarConstants.TYRE_INDEX_MISSING:
            return '--tyre-index-missing';
        case StatusbarConstants.POSTCODE_MISSING:
            return '--postcode-missing';
        default:
            return '';
    }
}

export default getStatusCssClassModifierByStatus;